import { render } from "./ServiceDetails3Page.vue?vue&type=template&id=5e508c8a&ts=true"
import script from "./ServiceDetails3Page.vue?vue&type=script&lang=ts"
export * from "./ServiceDetails3Page.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__